import React from 'react'
import { useHistory } from 'react-router'

import VAC_AlarmPopup from '@Components/VAC/alarm/VAC_AlarmPopup'
import usePopup from '@Hooks/popup/usePopup'

const AlarmRequestSuccessPopup: React.FC = () => {
  const { popup, changeInit } = usePopup()
  const { goBack, length } = useHistory()

  const handleClickConfirm = (evt: React.SyntheticEvent) => {
    evt.preventDefault()
    evt.stopPropagation()
    changeInit()
    if (length > 1) {
      goBack()
    } else {
      window.close()
    }
  }

  const popupProps = {
    popupList: {
      [popup.key]: { ...popup, confirmText: '확인', handleClickConfirm },
    },
  }

  return (
    <>
      <VAC_AlarmPopup popupList={popupProps.popupList} isHidden={false} />
    </>
  )
}
export default AlarmRequestSuccessPopup
